
export default {
  async asyncData({ $getContent }) {
    return {
      premium: await $getContent('premium'),
    }
  },
  head: {
    title: 'Premium',
  },
  async mounted() {
    await this.loadPremium()
  },
  methods: {
    async loadPremium(plan) {
      if (plan) {
        await this.$router.push({ path: this.$route.path, query: { plan } })
      } else if (this.$route.query.plan) {
        plan = this.$route.query.plan.toLowerCase()
      } else {
        return
      }

      if (plan === 'basic') {
        await this.showPremium('Basic', 30, 1)
      } else if (plan === 'pro') {
        await this.showPremium('Pro', 60, 3)
      } else if (plan === 'plus') {
        await this.showPremium('Plus', 90, 5)
      }
    },
    async showPremium(name, price, server) {
      if (this.$store.getters['user/isNull']) {
        const user = await this.$axios.$get('/users/@me').catch(async err => {
          if (err.response.status !== 401) this.$fatal(err)
          else
            await this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
        })

        if (!user) return

        this.$store.commit('user/set', user)
      }

      const user = this.$store.getters['user/get']
      const username = user.username.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      const message = this.$createElement('div', {
        domProps: {
          innerHTML: `
            <p class="font-weight-bold mb-2">${name} Plan (${server} servers)</p>
            <p class="mb-4">
              Before proceeeding to payment, please join our
              <a target="_blank" href="/support">support server</a> to receive the role and rewards.
            </p>
            <p class="mb-0">
              Signed in as ${username}.
              <a href="/logout">Not you?</a>
            </p>
            <form id="premium-form" action="https://www.paypal.com/cgi-bin/webscr" method="post"
                target="_top" novalidate>
              <input type="hidden" name="business" value="redfreebird41@gmail.com">
              <input type="hidden" name="lc" value="en_US">
              <input type="hidden" name="cmd" value="_xclick">
              <input type="hidden" name="amount" value="${price}.00">
              <input type="hidden" name="item_name" value="ModMail Premium (${name})">
              <input type="hidden" name="no_shipping" value="1">
              <input type="hidden" name="currency_code" value="USD">
              <input type="hidden" name="custom" value="${user.id}">
              <input type="hidden" name="notify_url" value="https://modmail.xyz/api/webhooks/payment">
              <input type="hidden" name="return" value="https://modmail.xyz/success">
              <input type="hidden" name="cancel_return" value="https://modmail.xyz/premium">
            </form>
          `,
        },
      })

      await this.$modal([message], {
        title: 'ModMail Premium',
        okTitle: 'Continue with PayPal',
        footerClass: 'test',
        cancelVariant: 'gray d-none',
      }).then(async res => {
        if (!res) {
          await this.$router.push({ path: this.$route.path })
          return
        }
        document.getElementById('premium-form').submit()
      })
    },
  },
}
